import React, { useState } from "react";
import clip from "../library/svg/clip.svg";
import cancel from "../library/svg/cancel.svg";
import { backendBookartUrl } from "../library/constants";
import axios from "axios";
import { Link } from "react-router-dom";

let EmailUs = () => {
  let queryTypes = [
    "Invoice copies",
    "Credit note copies",
    "Dispatch Details",
    "Order Status",
    "Cancellations",
    "Price and availability",
    "Returns",
  ];
  let toMail = window.sessionStorage.getItem("emailId");
  let [from] = useState(toMail);
  let [to] = useState("indiahsbooks@elsevier.com");
  let [cc, setCC] = useState("");
  let [subject, setSubject] = useState("");
  let [attachedFile, setAttachedFile] = useState("");
  let [query, setQuery] = useState("");
  let [queryType, setQueryType] = useState("");
  let [backEndResponse, setBackEndResponse] = useState(false);
  let [ccError, setCCError] = useState("");

  let uploadFile = (event) => {
    var ext = event.target.value.match(/\.([^\\.]+)$/)[1];
    let attachedFile = "";
    switch (ext) {
      case "xlsx":
      case "pdf":
      case "doc":
      case "docx":
        attachedFile = event.target.files[0];
        break;
      default:
        alert("Invalid file format, upload .xlsx/.pdf/.doc/.docx files.");
        attachedFile = "";
    }
    setAttachedFile(attachedFile);
  };

  let handleFileCancel = () => {
    setAttachedFile(null);
  };

  let validateEmail = (emails) => {

    // Regex to validate a single email address
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
    // Split the input string by commas and trim whitespace
    const emailList = emails.split(',').map(email => email.trim());
  
    // Validate each email in the list
    for (let email of emailList) {
      if (!emailPattern.test(email)) {
        return false;
      }
    }
  
    return true;
  };
  

  let handleCCChange = (event) => {
    const value = event.target.value;
    setCC(value);
    if (value && !validateEmail(value)) {
      setCCError("Please enter a valid email address.");
    } else {
      setCCError("");
    }
  };

  let submitQuery = (event) => {
    event.preventDefault();
    var formData = new FormData();
    formData.append("fromAddress", from);
    formData.append("toAddress", to);
    formData.append("ccAddress", cc);
    formData.append("subject", subject);
    formData.append("query", query);
    formData.append("attachedFile", attachedFile ? attachedFile : null);
    formData.append("queryType", queryType);
    const token = window.sessionStorage.getItem("JWTtoken");
    var config = {
      method: "post",
      url: `${backendBookartUrl}/email_query?=`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
      data: formData,
    };

    axios(config)
      .then((response) => {
        let response_from_backEnd = response.data.mail_sent;
        setAttachedFile(null);
        setBackEndResponse(response_from_backEnd);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  if (backEndResponse) {
    return (
      <div className="px-2 py-4">
        <h3>Thank You</h3>
        <p>Your query has been submitted</p>
        <Link to={"/list"} className="es-link colored">
          <button className="es-button primary">Continue Shopping</button>
        </Link>
      </div>
    );
  } else {
    return (
      <div>
        <form onSubmit={submitQuery}>
          <div className="es-input-text ">
            <input
              id="id-size3"
              name="size3"
              placeholder="&nbsp;"
              value={from}
              readOnly
            />
            <label htmlFor="id-size3">From </label>
          </div>
          <div className="es-input-text ">
            <input
              id="id-size3"
              name="size3"
              placeholder="&nbsp;"
              value={to}
              readOnly
              />
              <label htmlFor="id-size3">To </label>
            </div>
            <div className="es-input-text ">
              <input
                id="id-size3"
                name="size3"
                placeholder="&nbsp;"
                value={cc}
                onChange={handleCCChange} // Use the new handler for CC
              />
              <label htmlFor="id-size3">CC </label>
              {ccError && <div className="error-message">{ccError}</div>} {/* Display error message */}
            </div>
  
            <div className="es-listbox es-js-listbox">
              <label htmlFor="demo-id-1-ctry">Query Type*</label>
              <select
                onChange={(e) => {
                  setQueryType(e.target.value);
                  setSubject("regarding " + e.target.value);
                }}
                id="demo-id-1-ctry"
                required={true}
              >
                <option value="no-query"></option>
                {queryTypes.map((el, index) => {
                  return (
                    <option key={index} value={el}>
                      {el}
                    </option>
                  );
                })}
              </select>
              <svg viewBox="0 0 92 128" height="24" width="18">
                <path d="M1 51l7-7 38 38 38-38 7 7-45 45z" />
              </svg>
            </div>
            <div className="es-input-text ">
              <input
                id="id-size3"
                name="size3"
                placeholder="&nbsp;"
                value={subject}
                onChange={(event) => {
                  setSubject(event.target.value);
                }}
                required={true}
              />
              <label htmlFor="id-size3">Subject* </label>
            </div>
            <div className="formGroup file-upload-container">
              <div className="es-input-text small">
                <label htmlFor="attachment" className="color-black font-16">
                  Attachment{" "}
                  <span className="color-light-ash">
                    (supported format .xlsx/.pdf/.doc/.docx)
                  </span>
                </label>
                <br />
              </div>
              <label className="es-button primary upload-button pointer">
                &nbsp; Choose File
                <input
                  type="file"
                  name="attachment"
                  className="collapse"
                  onChange={uploadFile}
                  accept=".pdf,.xlsx, .doc, .docx"
                />
              </label>
              {attachedFile ? (
                <label>
                  <img src={clip} alt="clip" />
                  <span className="uploaded-file-name">{attachedFile.name}</span>
                  <img
                    className="pointer"
                    onClick={handleFileCancel}
                    src={cancel}
                    alt="cancel"
                  />
                </label>
              ) : (
                <label></label>
              )}
            </div>
            <div className="formGroup">
              <div className="es-input-text small">
                <label className="color-light-ash">Enter Your Query</label>
                <br />
                <textarea
                  className="es-textbox color-more-light-ash"
                  value={query}
                  onChange={(event) => setQuery(event.target.value)}
                ></textarea>
              </div>
            </div>
            <div className="formGroup">
              <button className="es-button primary medium" type="submit">
                <span>Submit Query</span>
                <svg
                  focusable="false"
                  height="24"
                  viewBox="0 0 54 128"
                  width="11"
                >
                  <path d="M1 99l38-38L1 23l7-7 45 45-45 45z" />
                </svg>
              </button>
            </div>
          </form>
        </div>
      );
    }
  };
  
  export default EmailUs;